import { Fragment, useCallback } from 'react';
import { Linking, StyleSheet, View } from 'react-native';
import { RouteProp, useRoute } from '@react-navigation/native';
import { Divider } from '@ui-kitten/components';

import Button from '../../../Components/Button';
import { textCategory } from '../../../Components/Reservation/constants';
import ResponsiveText from '../../../Components/ResponsiveText';
import constants from '../../../Config/constants';
import RouteList, { ReservationNavigatorProps } from '../../../Routes/list';
import themeStyle from '../../../Theme/styles';

const BookPrivateEvent = ({ socialLink }: { socialLink: string }) => {
  const route =
    useRoute<
      RouteProp<ReservationNavigatorProps, RouteList.RES_STORE_DETAILS>
    >();
  const isEventTab =
    route.params?.defaultTab === constants.RESERVATION_TYPE.EVENT;
  const _onBookPrivateEvent = useCallback(() => {
    Linking.openURL(socialLink);
  }, [socialLink]);

  if (isEventTab || !socialLink) return null;

  return (
    <Fragment>
      <Divider style={themeStyle.divider} />
      <View style={themeStyle.pageVerticalSpacing}>
        <ResponsiveText
          category={textCategory.HEADING}
          style={[themeStyle.spacingBottomMedium, themeStyle.bold]}
        >
          Private Events
        </ResponsiveText>
        <ResponsiveText
          category={textCategory.BODY}
          style={themeStyle.spacingBottom}
        >
          If you would like to secure a reservation for a private event, please
          send us your request. Our team is ready to accommodate your
          celebration—whether it is a birthday, corporate gathering, or any
          special occasion.
        </ResponsiveText>
        <View style={themeStyle.alignItemsStart}>
          <Button
            appearance="outline"
            status="basic"
            style={styles.noPadding}
            onPress={_onBookPrivateEvent}
          >
            {() => (
              <ResponsiveText
                category={textCategory.BODY}
                style={themeStyle.pageHorizontalSpacing}
              >
                Chat with us
              </ResponsiveText>
            )}
          </Button>
        </View>
      </View>
    </Fragment>
  );
};

const styles = StyleSheet.create({
  noPadding: {
    paddingVertical: 0,
  },
});

export default BookPrivateEvent;
